import React, { Component } from "react";
import { FiChevronRight, FiPlusCircle } from "react-icons/fi";
import Spinner from "../../../base/features/micro/Spinner";
import ProductCard from "../../../base/features/blocks/ProductCard";
import { apiService } from "../../../base/utils/service";
import { addresses } from "../../addresses/services";
import { Link, Redirect } from "react-router-dom";
import RadioBtn from "../blocks/RadioBtn";
import Footer from "../blocks/Footer";
import Empty from "../../../base/features/blocks/Empty";
import { getShopUid } from "../../../settings/domainManager";
import {
  navigate_to_cart,
  navigate_to_cart_invoice,
} from "../../../navigator/user/cart";

class CartOrder extends Component {
  constructor(props) {
    super(props);
    this.state = {
      products: null,
      des: "",
      payment: "",
      payable_price: null,
      addresses: null,
      need_address: false,
      selectedAddressUid: null,
      shop_uid: getShopUid(),
    };
  }
  componentDidMount() {
    this.getCartItems();
  }
  getCartItems() {
    let shop_uid = getShopUid();
    apiService(`v1/shops/${shop_uid}/cart/finalize`, "get", null, true).then(
      (items) => {
        if (
          items.response &&
          items.response.status &&
          items.response.status === 404
        ) {
          this.setState({ redirect: true });
          return;
        }
        if (items && !items.response) {
          this.setState({
            products: items.items,
            cart_uid: items.uid,
            shippingConfigs: items.shipping_configs,
            shipping:
              items.shipping ||
              (items.shipping_configs && items.shipping_configs.length === 1)
                ? items.shipping_configs[0]
                : null,
            shop_uid: items.shop.uid,
            payable_price: items.payable_price,
            need_address: items.need_address,
            des: items.des,
            payments: items.payments,
            selectedAddressUid: items.address ? items.address : null,
          });
          if (items.need_address) {
            this.getAddresses();
          }
        }
      }
    );
  }
  getAddresses() {
    addresses().then((items) => {
      items &&
        this.setState({
          addresses: items.results,
        });
    });
  }
  set_new_address(selectedAddressUid) {
    this.setState({ selectedAddressUid: selectedAddressUid });
  }
  render() {
    return (
      <div className="container-fluid px-0">
        {this.state.redirect && <Redirect to={navigate_to_cart()} />}
        <header
          className="row mx-0 px-3 py-2-3 position-fixed bg-white shadow-sm"
          style={{ top: "0", right: "0", left: "0", zIndex: "4" }}
        >
          <div className="col-auto align-self-center px-0">
            <FiChevronRight
              size="26"
              className=""
              onClick={() => window.history.back()}
            />
          </div>
          <div className="col text-center align-self-center px-0">
            <h1 className="fs-5 fw-bolder mb-0">ثبت سفارش</h1>
          </div>
        </header>
        <body style={{ marginTop: "70px", marginBottom: "80px" }}>
          {this.state.need_address && (
            <div className="row mx-0 px-4">
              <div className="col px-0 fw-bolder fs-6 align-self-center">
                انتخاب آدرس
              </div>
              <Link
                className="col-auto px-0 fw-bolder fs-6 color-main align-self-center"
                to={{
                  pathname: "/map",
                  state: {
                    fromCartOrder: true,
                  },
                }}
              >
                <FiPlusCircle size="20" className="ms-1" />
                <span>آدرس جدید</span>
              </Link>
              {this.state.addresses ? (
                this.state.addresses.length > 0 ? (
                  this.state.addresses.map((address, a) => (
                    <RadioBtn
                      address={address}
                      checked={this.state.selectedAddressUid === address.uid}
                      address_change={(selectedAddressUid) =>
                        this.set_new_address(selectedAddressUid)
                      }
                    />
                  ))
                ) : (
                  <div className="row mx-0">
                    <Empty text={"هنوز آدرسی اضافه نکرده اید"} />
                  </div>
                )
              ) : (
                <Spinner />
              )}
            </div>
          )}
          {this.state.need_address &&
            this.state.shippingConfigs &&
            this.state.shippingConfigs.length > 0 && (
              <div className="row mx-0 mt-4 px-4">
                <div className="col-12 px-0">
                  <p className="fw-bolder fs-6">شیوه ارسال</p>
                </div>
                {this.state.shippingConfigs.map((config, c) => (
                  <div
                    className="row mx-0 rounded14 border p-3 mb-2"
                    onClick={() => this.setState({ shipping: config })}
                  >
                    <div className="col-2 px-0 text-center align-self-center">
                      <input
                        class="form-check-input mt-0 ms-3 align-middle color-second d-inline-block"
                        type="radio"
                        name="postingRadio"
                        checked={
                          this.state.shipping &&
                          this.state.shipping.uid === config.uid
                            ? true
                            : false
                        }
                        value={config.uid}
                      />
                    </div>
                    <div className="col-10 px-0">
                      <p className="fw-bold mb-1">{config.title}</p>
                      <p className="fw-bold fs-7 mb-0">{config.des}</p>
                    </div>
                  </div>
                ))}
              </div>
            )}
          {this.state.payments && (
            <div className="row mx-0 mt-4 px-4">
              <div className="col-12 px-0">
                <p className="fw-bolder fs-6">شیوه پرداخت</p>
              </div>
              {this.state.payments.has_card && (
                <div
                  className="row mx-0 rounded14 border p-3"
                  onClick={() => this.setState({ payment: "card" })}
                >
                  <div className="col-2 px-0 text-center align-self-center">
                    <input
                      class="form-check-input mt-0 ms-3 align-middle color-second d-inline-block"
                      type="radio"
                      name="paymentRadio"
                      checked={this.state.payment === "card"}
                      value={"card"}
                    />
                  </div>
                  <div className="col-10 px-0">
                    <p className="fw-bold mb-1">ارسال فیش واریز وجه</p>
                    <p className="fw-bold fs-7 mb-0">
                      واریز مبلغ سفارش برای فروشنده و آپلود رسید واریز
                    </p>
                  </div>
                </div>
              )}
              {this.state.payments.on_spot && (
                <div
                  className="row mx-0 rounded14 border p-3 mt-3"
                  onClick={() => this.setState({ payment: "spot" })}
                >
                  <div className="col-2 px-0 text-center align-self-center">
                    <input
                      class="form-check-input mt-0 ms-3 align-middle color-second d-inline-block"
                      type="radio"
                      name="paymentRadio"
                      checked={this.state.payment === "spot"}
                      value={"spot"}
                    />
                  </div>
                  <div className="col-10 px-0">
                    <p className="fw-bold mb-1">پرداخت در محل</p>
                    <p className="fw-bold fs-7 mb-0">
                      پرداخت مبلغ سفارش در هنگام تحویل به شما
                    </p>
                  </div>
                </div>
              )}
              {this.state.payments.has_gateway && (
                <div
                  className="row mx-0 rounded14 border p-3 mt-3"
                  onClick={() => this.setState({ payment: "gateway" })}
                >
                  <div className="col-2 px-0 text-center align-self-center">
                    <input
                      class="form-check-input mt-0 ms-3 align-middle color-second d-inline-block"
                      type="radio"
                      name="paymentRadio"
                      checked={this.state.payment === "gateway"}
                      value={"gateway"}
                    />
                  </div>
                  <div className="col-10 px-0">
                    <p className="fw-bold mb-1">پرداخت اینترنتی</p>
                    <p className="fw-bold fs-7 mb-0">
                      پرداخت مبلغ سفارش با درگاه های پرداخت الکترونیک
                    </p>
                  </div>
                </div>
              )}
            </div>
          )}
          <div className="row mx-0">
            <div className="col-12 mt-4 px-4">
              <p className="fw-bolder fs-6">توضیحات</p>
              <textarea
                value={this.state.des}
                onChange={(e) => this.setState({ des: e.target.value })}
                className="form-control rounded14 p-3"
                placeholder="توضیحات سفارش"
                rows="4"
              />
            </div>
          </div>
          <div className="row mx-0">
            <div className="col-12 mt-4 px-4">
              <p className="fw-bolder fs-6">محصولات</p>
            </div>
            {this.state.products &&
              (this.state.products.length > 0 ? (
                this.state.products.map((product, p) => (
                  <div key={p} className="col-12 px-0 border-bottom">
                    <ProductCard
                      product={product.product}
                      shopUid={this.state.shop_uid}
                      payable_price={product.payable_price}
                      quantity={product.quantity}
                      isOrder={true}
                    />
                  </div>
                ))
              ) : this.state.products.length === 0 ? (
                <div className="col text-center mt-5">
                  <img
                    alt=""
                    width="50%"
                    src={
                      require("../../../base/assets/icons/notFound.svg").default
                    }
                  />
                  <p className="mt-2">سبد خرید شما خالی است.</p>
                </div>
              ) : (
                <Spinner />
              ))}
          </div>
        </body>
        {this.state.products &&
          this.state.payable_price &&
          this.state.products.length > 0 && (
            <Footer
              payable_price={this.state.payable_price}
              btnText={"ادامه"}
              path={navigate_to_cart_invoice(
                this.state.cart_uid,
                this.state.payment
              )}
              type={"order"}
              params={{
                des: this.state.des,
                shipping: this.state.need_address
                  ? this.state.shipping && this.state.shipping.uid
                  : "",
                address: this.state.need_address
                  ? this.state.selectedAddressUid
                  : "",
              }}
              shopUid={this.state.shop_uid}
              isDisabled={
                (this.state.need_address && !this.state.selectedAddressUid) ||
                !this.state.payment ||
                (this.state.need_address &&
                  this.state.shippingConfigs &&
                  this.state.shippingConfigs.length > 0 &&
                  !this.state.shipping)
                  ? true
                  : false
              }
            />
          )}
      </div>
    );
  }
}

export default CartOrder;
